export default "__VITE_ASSET__6wBr5EV3__ 640w, __VITE_ASSET__DMKp08cv__ 1024w, __VITE_ASSET__CjFmz0O4__ 1536w";